export default __webpack_public_path__ + "static/media/DNo.27-4.809a56c5.jpg";